/*  MUI  */
import { Theme } from '@mui/material/styles';

export const getScoreFillColor = ({
    value,
    theme
}: {
    value: number;
    theme: Theme;
}) => {
    if (typeof value !== 'number') {
        return theme.palette.saasScore.fillColor.none;
    }
    if (value < 40) {
        return theme.palette.saasScore.fillColor.low;
    }
    if (value < 70) {
        return theme.palette.saasScore.fillColor.medium;
    }

    return theme.palette.saasScore.fillColor.excellent;
};

export const getScoreUnfilledColor = ({
    value,
    theme
}: {
    value: number;
    theme: Theme;
}) => {
    if (typeof value !== 'number') {
        return theme.palette.saasScore.unfilledColor.none;
    }
    if (value < 40) {
        return theme.palette.saasScore.unfilledColor.low;
    }
    if (value < 70) {
        return theme.palette.saasScore.unfilledColor.medium;
    }
    return theme.palette.saasScore.unfilledColor.excellent;
};
